var render, staticRenderFns
import script from "./ot-workflow-question-indent.vue?vue&type=script&lang=ts&"
export * from "./ot-workflow-question-indent.vue?vue&type=script&lang=ts&"
import style0 from "./ot-workflow-question-indent.vue?vue&type=style&index=0&id=fd557d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd557d56",
  null
  
)

export default component.exports